<template>
  <div id="app">
    <LandingPage
      v-if="showLandingPage"
      @enter-app="showLandingPage = false"
    />

    <template v-else>
      <!-- Top Controls (global) -->
      <div
        v-if="!$route?.meta?.hideTopControls"
        class="top-controls"
      >
        <!-- Dashboard button -->
        <router-link
          v-if="!$route?.meta?.hideDashboardButton"
          to="/dashboard"
          class="dash-btn"
        >
          Dashboard
        </router-link>

        <!-- Location selector -->
        <div
          v-if="!$route?.meta?.hideLocationSelector"
          class="location-selector"
        >
          <label for="location">Location:</label>
          <select
            id="location"
            v-model="selectedLocation"
            @change="saveLocation"
          >
            <option value="F">Fresno</option>
            <option value="D">Denver</option>
            <option value="K">Knoxville</option>
            <option value="L">Lakeland</option>
          </select>
        </div>
        <!-- Logout -->
        <button class="logout-btn" @click="logout">
          Logout
        </button>
      </div>

      <router-view @locationChanged="updateLocation" />
    </template>
  </div>
</template>

<script>
import LandingPage from "./components/LandingPage.vue";
import axios from "axios";

export default {
  components: { LandingPage },
  data() {
    return {
      showLandingPage: false,
      selectedLocation: localStorage.getItem("selectedLocation") || "D",
    };
  },
  methods: {
    updateLocation(newLocation) {
      this.selectedLocation = newLocation;
      localStorage.setItem("selectedLocation", newLocation);
    },
    saveLocation() {
      localStorage.setItem("selectedLocation", this.selectedLocation);
    },

    async logout() {
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          await axios.post('/auth/logout', {
            refresh_token: refreshToken,
          });
        }
      } catch (e) {
        // Swallow errors — logout should always succeed client-side
        console.warn('Logout request failed:', e);
      } finally {
        // Clear local state no matter what
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('selectedLocation');

        this.$router.replace('/');
      }
    }

  },
};
</script>

<style scoped>
#app {
  font-family: Garamond, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #f9fafb;
}

/* Global top-left cluster */
.top-controls {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 999999;

  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

/* Dashboard button */
.dash-btn {
  display: inline-block;
  text-decoration: none;

  background-color: #111827;
  color: #e5e7eb;
  border: 1px solid rgba(203, 191, 191, 0.25);
  border-radius: 10px;
  margin-top: 20px;

  padding: 8px 12px;
  font-weight: 700;
  font-size: 14px;

  transition: background-color 0.15s ease, transform 0.15s ease, opacity 0.15s ease;
  opacity: 0.92;
}

.dash-btn:hover {
  background-color: #1f2933;
  transform: translateY(-1px);
  opacity: 1;
}

/* Location selector */
.location-selector {
  background: #5595b7c2;
  padding: 8px 10px;
  border-radius: 6px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);

  font-weight: bold;
  color: #0b0101;

  opacity: 0.92;
  transition: opacity 0.15s ease;
}

.location-selector:hover {
  opacity: 1;
}

.location-selector select {
  margin-left: 6px;
}

.logout-btn {
  background-color: #7affe276;            /* unscheduled card wash */
  color: #0b0101;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;

  padding: 8px 12px;
  font-weight: 800;
  font-size: 13px;

  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
  cursor: pointer;

  transition: transform 0.12s ease, background-color 0.12s ease, box-shadow 0.12s ease;
}

.logout-btn:hover {
  transform: translateY(-1px);
  background-color: #5595b7c2;
  color: #0b0101;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.28);
}

</style>
